import useStyles from './global.styles';

const GlobalStyles = () => {
  const styles = useStyles();

  return null;
};

export default GlobalStyles;
